import { render, staticRenderFns } from "./Photograph.vue?vue&type=template&id=6f399aab"
import script from "./Photograph.vue?vue&type=script&lang=js"
export * from "./Photograph.vue?vue&type=script&lang=js"
import style0 from "./Photograph.vue?vue&type=style&index=0&id=6f399aab&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports